import axios from 'axios';

import VanguardConfig from '../../../config/vanguard';

/**
 * PostgreSalesforce API
 */
export default class pgsfApi {
  constructor() {
    this.baseHost = VanguardConfig.pgsfUrl;
  }

  /**
   * This call return the map of the product bougth by a client (those data are not really in real time, we could consider 1h of delta)
   * @param  {String}  sfId Salesforce contact ID
   * @return {Promise}
   *
   * https://hsp6mn16j0.execute-api.eu-central-1.amazonaws.com/preprod
   */
  getActiveProducts(salesforceId = null, email = null, affiliateId = null) {
    console.log('pgApi:getActiveProducts', salesforceId, email, affiliateId);
    return new Promise((resolve, reject) => {
      try {
        const parameters = {
          salesforceId: salesforceId || '',
          email: email || '',
          affiliateId: affiliateId || ''
        };

        const url = `${this.baseHost}/processfront?action=activeProducts&action_infos=${encodeURIComponent(JSON.stringify(parameters))}`;
        axios.get(url).then(response => {
          if (!response.status || response.status >= 300 || !response.data) {
            return reject(new Error(`processfront status failed ${JSON.stringify(response)}`));
          }

          if (response.data.body.code <= 204) {
            resolve(response.data.body.data === null ? [] : response.data.body.data);
          } else {
            reject(new Error(response.data.body.message));
          }
        }, error => {
          reject(new Error(error));
        });
      } catch (error) {
        reject(new Error(error));
      }
    });
  }

  getAlreadyContractedProducts(sfId, affiliateId, products) {
    const parameters = {sfId, affiliateId, products};
    const url = `${this.baseHost}/processfront?action=alreadyContracted&action_infos=${encodeURIComponent(JSON.stringify(parameters))}`;
    return axios.get(url);
  }


  getPrefillData(sfId, affiliateId, raw = false, currentChoiceId = null) {
    console.log('pgApi:getPrefillData', sfId, affiliateId);
    return new Promise((resolve, reject) => {
      try {
        const parameters = {
          polarisId: sfId,
          affiliateId
        };

        if (currentChoiceId) {
          parameters.choiceId = currentChoiceId;
        }

        const url = `${this.baseHost}/processfront?action=contact&action_infos=${encodeURIComponent(JSON.stringify(parameters))}`;
        axios.get(url).then(response => {
          if (!response.status || response.status >= 300 || !response.data) {
            return reject(new Error(`processfront status failed ${JSON.stringify(response)}`));
          }

          if (response.data.body.code <= 204) {
            const result = raw ? response.data.body.data : this.transformContactData(response.data.body.data);
            resolve(result);
          } else {
            reject(new Error(response.data.body.message));
          }
        }, error => {
          reject(new Error(error));
        });
      } catch (error) {
        reject(new Error(error));
      }
    });
  }

  getOrdersData(sfId, affiliateId) {
    console.log('pgApi:getOrdersData', sfId, affiliateId);
    return new Promise((resolve, reject) => {
      try {
        const parameters = {
          sfId,
          affiliateId
        };
        const url = `${this.baseHost}/processfront?action=contract&action_infos=${encodeURIComponent(JSON.stringify(parameters))}`;
        axios.get(url).then(response => {
          if (!response.status || response.status >= 300 || !response.data) {
            return reject(new Error(`processfront status failed ${JSON.stringify(response)}`));
          }

          if (response.data.body.code <= 204) {
            resolve(this.transformContractsData(response.data.body.data));
          } else {
            reject(new Error(response.data.body.message));
          }
        }, error => {
          reject(new Error(error));
        });
      } catch (error) {
        reject(new Error(error));
      }
    });
  }

  transformContactData(data) {
    const response = {
      status: true,
      content: {}
    };

    if (!data || !data[0] || !data[0].contact) {
      return response;
    }

    const contactData = data[0].contact;

    response.content = {
      BILLINGCITY__C: contactData.BillingCity__c,
      BILLINGCOUNTRY__C: contactData.BillingCountry__c,
      BILLINGSTREET1__C: contactData.BillingStreet1__c,
      BILLINGSTREET2__C: contactData.BillingStreet2__c,
      BILLINGSTREET3__C: contactData.BillingStreet3__c,
      BILLINGSTREET4__C: contactData.BillingStreet4__c,
      BILLINGZIPCODE__C: contactData.BillingZipCode__c,
      EMAIL: contactData.Email,
      EMAILENCRYPTED__C: contactData.EmailEncrypted__c,
      FIRSTNAME: contactData.FirstName,
      LASTNAME: contactData.LastName,
      PHONE: contactData.Phone,
      GENDER: contactData.Gender__c
    };
    return response;
  }

  transformContractsData(data) {
    const response = {
      status: true,
      content: []
    };

    if (!data) {
      return response;
    }

    response.content = data.map(product => {
      product.PRODUCT__C = product.Product__c;
      return product;
    });
    return response;
  }
}



// WEBPACK FOOTER //
// ./src/common/api/pg-api.js